import React, { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import { BoxImage } from "./boxImage";
import { getImage } from "../../../service/upload/getImage";
import { UseConvertImageToBase64 } from "../../hooks/use-convert-image-to-base-64";

// BoxImage for a stored image key (e.g. a table row's raw `image` field).
// BoxImage itself needs the loaded base64, not the key.
export const BoxImageByKey = ({ imageKey, ...props }) => {
  const [image, setImage] = useState(null);
  useEffect(() => {
    let active = true;
    getImage(imageKey).then((data) => {
      if (active) setImage(UseConvertImageToBase64(data));
    });
    return () => {
      active = false;
    };
  }, [imageKey]);

  if (!image) {
    return (
      <Skeleton
        sx={{ borderRadius: "8px" }}
        variant="rectangular"
        width={props.width}
        height={props.height}
      />
    );
  }
  return <BoxImage image={image} {...props} />;
};
